/* eslint-disable */
import { EventBus } from '@/event-bus';
import { generic_storage } from '../_utilities/generic_storage';
import { collateralService, sectionService } from '../_services';

const extendedCollateralStore = generic_storage('collateralService');

// State.
extendedCollateralStore.state.count = 0;
extendedCollateralStore.state.is_test = false;

extendedCollateralStore.mutations.updateIsTest = function (state, is_test) {
  state.is_test = is_test;
};

// Actions.
extendedCollateralStore.actions.fetchAll = function ({ commit }, args = null) {
  commit('setIsLoading', true);
  collateralService.getItems(args).then((response) => {
    commit('updateItems', response.data.results);
    commit('updateCount', response.data.count);
  }).finally(() => {
    commit('setIsLoading', false);
  });
};

extendedCollateralStore.actions.addPage = function ({ commit }, args = null) {
  commit('setIsLoading', true);
  return new Promise((resolve, reject) => {
    collateralService.getItems(args).then((response) => {
      // commit('reset');
      commit('addItemPage', response.data.results);
      commit('updateItemsCount', response.data.count);
      resolve(response);
    })
      .catch((e) => reject(e))
      .finally(() => {
        commit('setIsLoading', false);
      });
  });
};

extendedCollateralStore.actions.deleteItemWithoutAll = function ({ commit, dispatch }, args) {
  commit('setIsLoading', true);
  return collateralService.deleteItem(args.id).then((response) => {
    console.log('Item was deleted successfully');
    /*
    delete args.id;
    dispatch('getAll', args);
    */
    commit('removePhotoLocally', args.id);
    EventBus.$emit('toast-success', 'Image deleted');
  }).finally(() => {
    commit('setIsLoading', false);
  });
};

extendedCollateralStore.actions.getSharedCollages = function ({ commit, dispatch }, args) {
  commit('setIsLoading', true);
  return sectionService.fetchAsCollaterals(args).then((response) => {
    console.log('Splice ...', response);
    if (args.page && args.page_size) {
      commit('addItemPage', response.data.results);
      commit('updateItemsCount', response.data.count);
    } else {
      commit('updateItems', response.data.results);
      commit('updateCount', response.data.count);
    }
  }).finally(() => {
    commit('setIsLoading', false);
  });
};

extendedCollateralStore.actions.downloadImage = function ({ commit }, id) {
  return collateralService.downloadImage(id).then((response) => response);
};

extendedCollateralStore.actions.hideSharedCollage = function ({ commit, dispatch }, args) {
  commit('setIsLoading', true);
  return sectionService.patchItem(args.itemPk, args.payload).then((response) => {
    dispatch('getSharedCollages');
  }).finally(() => {
    commit('setIsLoading', false);
  });
};

extendedCollateralStore.actions.updateLike = function ({ commit, dispatch }, args) {
  commit('updateLike', args);
};

extendedCollateralStore.actions.shareAlbumPage = function ({ commit, dispatch }, args = null) {
  commit('setIsLoading', true);
  return collateralService.getSharedItems(args).then((response) => {
    commit('addItemPage', response.data.results);
    commit('updateItemsCount', response.data.count);
    commit('fonts/updateFontName', response.data.institution.default_font.font_family, { root: true });
    commit('institutions/updateLogoURL', response.data.institution.logo, { root: true });
    commit('updateIsTest', response.data.is_test);
    dispatch('fonts/injectFontsAnonymousUser', response.data.institution.pk, { root: true });
    return response;
  }).catch(() => {
    // display error message
  }).finally(() => {
    commit('setIsLoading', false);
  });
};

// Mutations.
extendedCollateralStore.mutations.updateCount = function (state, count) {
  state.count = count;
};

extendedCollateralStore.mutations.updateLike = function (state, args) {
  const item = state.items.find((el) => el.pk === args.pk);
  item.liked = args.liked;
};

extendedCollateralStore.mutations.removePhotoLocally = function (state, photoId) {
  // Remove photo on the store so it wont trigger the reload on the site
  const deletedObject = state.items.find((item) => item.pk === photoId);
  if (deletedObject === undefined) return;
  const objectIndex = state.items.indexOf(deletedObject);
  state.items.splice(objectIndex, 1);
  state.count -= 1; // Decrease the count amount on the state
};

export const collateral = extendedCollateralStore;
